export default __webpack_public_path__ + "static/media/ClassRoomChat.5ace7e28.png";